import notification from "@/services/notify";
//import { raygun } from "@/services/raygun";
import { refreshToken } from "@/services/refresh";
import httpGetCached from "@/services/httpGetCached";
import { getLocalRoutes, getRoutes, refreshRoutes, evaluateString, findChildRecord, findRecordByUUID, getPathArray, getRouteDetailArray, getFullPathArray, routeHasNullParams } from "@/services/routeSetup";
import { getPage } from "@/services/utils/contentUtils";
import { assignmentStatus } from "@/services/utils/mclUtils";
import jsObjectUtils from "@/services/jsObjectUtils";
import mobileCheck from "@/services/mobileCheck";
import hasSlotContent from "@/services/hasSlotContent";
import pdf from "@/services/pdf";
import confirm from "@/services/confirm";
import popup from "@/services/popup";
import saveOrDiscard from "@/services/saveOrDiscard";
import { OGNode } from "@/services/openGraph";
import jsonTools from "@/services/json";
import debouncer from "@/services/debouncer";
export default {
    notification,
    //raygun,
    refreshToken,
    httpGetCached,
    getLocalRoutes,
    getRoutes,
    refreshRoutes,
    evaluateString,
    findChildRecord,
    findRecordByUUID,
    getPathArray,
    getRouteDetailArray,
    getFullPathArray,
    routeHasNullParams,
    mobileCheck,
    hasSlotContent,
    pdf,
    confirm,
    popup,
    saveOrDiscard,
    Utils: {
        assignmentStatus,
        getPage
    },
    jsObjectUtils,
    OGNode,
    jsonTools,
    debouncer
};
